import { render, staticRenderFns } from "./WordCloudWidgetPreview.vue?vue&type=template&id=dbb54030"
import script from "./WordCloudWidgetPreview.vue?vue&type=script&lang=js"
export * from "./WordCloudWidgetPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports